import { useApi } from './useApi';
import { apiService } from '../services/api';

interface StrapiImageFormat {
  url: string;
  width: number;
  height: number;
  size: number;
  ext: string;
  mime: string;
  hash: string;
  name: string;
  path: string | null;
  sizeInBytes: number;
}

interface BeforeAfterSliderItem {
  id: number;
  documentId: string;
  altText: string;
  order: number;
  image?: {
    id: number;
    url: string;
    alternativeText?: string;
    formats?: {
      large?: StrapiImageFormat;
      medium?: StrapiImageFormat;
      small?: StrapiImageFormat;
      thumbnail?: StrapiImageFormat;
    };
    width?: number;
    height?: number;
  };
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

export function useBeforeAfterSlider() {
  return useApi<BeforeAfterSliderItem[]>(apiService.getBeforeAfterSlider);
} 